export default {"src":"/_next/static/image/public/images/ic_shield.4df023ac240d91c58d8858a98974d681.svg","height":22,"width":18};